// sort-imports-ignore
// Initialize monitoring before application modules execute.
import './shared/configs/sentry'

import React from 'react'

import { ErrorBoundary } from '@sentry/react'
// touch screen polyfill for html5 dnd
import 'drag-drop-touch'
import { createRoot } from 'react-dom/client'
import { GlobalErrorPage } from 'shared/components/GlobalErrorPage/GlobalErrorPage'

import { App } from './App'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Failed to find the root element')
}

const root = createRoot(container)

root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<GlobalErrorPage />}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
)
